<template>
    <section id="unsaved-changes">
        <b-modal 
            @hide="onHide" 
            id="unsaved-changes-modal" 
            ref="unsavedChanges" 
            hide-header 
            hide-footer>
                <div class="unsaved-changes">
                    <div class="text-right mb-3">
                        <p class="eina-semibold p2b mb-1">{{title}}</p>
                        <p class="p2n mb-0">{{text}}</p>
                    </div>
                    <div data-name="action-buttons" class="text-right">
                        <Button
                            id="close-btn"
                            @click.native="$emit('no')"
                            type="gray">
                                {{noText}}
                        </Button>
                        <Button
                            id="save-btn"
                            class="ml-2"
                            :disabled="loading"
                            @click.native="$emit('submit')"
                            type="primary">
                                {{saveText}}
                        </Button>
                    </div>
                </div>
        </b-modal>
    </section>
</template>

<script>
import Button from '../components/Theme/Button'

export default {
    name: 'UnsavedChanges',
    components: {
        Button
    },
    mounted: function() {
        this.$bvModal.show('unsaved-changes-modal')
    },
    props: {
        loading: Boolean,
        title: {
            type: String,
            default: 'You have unsaved changes'
        },
        text: {
            type: String,
            default: 'Do you want to keep them?'
        },
        saveText: {
            type: String,
            default: 'Save'
        },
        noText: {
            type: String,
            default: 'No'
        }
    },
    methods: {
        onHide: function(evt) {
            this.$bvModal.hide('unsaved-changes-modal')
            setTimeout(() => {
                this.$emit('close')
            })
        },
    }
}
</script>

<style lang="scss">
    #unsaved-changes-modal {
        .modal-dialog {
            max-width: fit-content;
            float: right;
            margin: 2rem!important;
        }
        .modal-backdrop {
            opacity: 0.6;
        }
    }
</style>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

div.unsaved-changes {
    width: fit-content;
    padding: 20px 24px;;
    background: #FFFFFF;
    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
    border-radius: 12px;

    div[data-name="action-buttons"] {
        button {
            padding: 8px 20px;
        }
    }

}
</style>